import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/* eslint-disable no-useless-escape */

/*
 * @Description: ATM统一上报组件
 * @Author: suzyli
 * @Date: 2020-01-06 19:49:40
 * @LastEditTime: 2021-05-06 15:54:31
 */

/* global  ActiveXObject */
// 降域，方便iframe中转页通信，判断来源
import miloCookie from '../common/cookie';
import miloObject from '../common/object';
import platform from '../common/platform';
import { g } from '../common/base';
import url from '../common/url';
var Url = url;

var _isQQDomain = function isQQDomain() {
  return /(\.qq\.com)$/.test(document.location.host);
};

var _getRealCgi = function getRealCgi() {
  var sCgi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var sRealCgi = sCgi;

  if (!sRealCgi) {
    sRealCgi = location.href;
  }

  try {
    sRealCgi = sRealCgi.match(/^([^\?^\#]+)(\?[^\#]*)*(\#.*)*$/)[1];
  } catch (err) {
    sRealCgi = '';
    console.log('get sCgi error,', err);
  }

  return sRealCgi;
};

if (_isQQDomain()) {
  document.domain = 'qq.com';
}

var comm = {
  atmUrl: 'https://ams.game.qq.com/log?sCloudApiName=atm',
  // 要请求的atm后台地址
  crossDomainUrl: 'https://ams.game.qq.com/ams/postATM.html' // 中转页面地址

}; // 整合对象

var assignValue = function assignValue(defaultData, data) {
  for (var k in data) {
    if (data[k] !== undefined) {
      defaultData[k] = data[k];
    } else if (defaultData[k] === undefined) {
      defaultData[k] = '';
    }
  }

  return defaultData;
};

var getGameId = function getGameId(s_url) {
  var url = s_url || window && window.location.host || '';
  var gameId = url.replace(/(\w+?)\.qq\.com/ig, '$1');
  return gameId == url ? '' : gameId;
}; // frame管理


var ATM = /*#__PURE__*/function () {
  function ATM() {
    _classCallCheck(this, ATM);

    this.visitFromModule = 3; // 默认为milo-core来源
    // 设置上报防重标识

    if ('object' !== _typeof(window.ATMVisitFlag)) {
      window.ATMVisitFlag = {};
    }
  }

  _createClass(ATM, [{
    key: "getRealCgi",
    value: function getRealCgi() {
      return _getRealCgi.apply(void 0, arguments);
    }
  }, {
    key: "isQQDomain",
    value: function isQQDomain() {
      return _isQQDomain.apply(void 0, arguments);
    }
  }, {
    key: "getUin",
    value: function getUin() {
      var t = miloCookie.get('IED_LOG_INFO2');
      var IED_LOG_INFO2 = t == null ? null : miloObject.unSerialize(t);

      if (IED_LOG_INFO2 == null) {
        return '';
      }

      var uin = IED_LOG_INFO2.userUin;
      return !isNaN(uin) ? uin : miloCookie.get('uin');
    }
  }, {
    key: "setFromModule",
    value: function setFromModule(id) {
      this.visitFromModule = id;
    } // 组织数据和参数,包括但不限于校验，过滤等

  }, {
    key: "reportATM",
    value: function reportATM(data, callback) {
      // 非QQ域名处理
      if (!_isQQDomain()) {
        return;
      }

      try {
        var originalData = {
          fromappid: 38,
          // milo 应用id
          frommoduletype: this.visitFromModule,
          // 管线milo-next:7,websdk:5,milo-core:3,
          toreturncode: 1,
          result: 1,
          struserid: miloCookie.get('openid') || this.getUin(),
          // 微信openid或者qq号
          serialtime: parseInt(new Date().getTime() / 1000)
        };

        if (_typeof(data) === 'object') {
          originalData = assignValue(originalData, data);
        } // amesvr


        if ('string' === typeof originalData.tomoduletype) {
          var tonode = originalData.tomoduletype;
          originalData.tomoduletype = originalData.tomoduletype.indexOf('amesvr') > -1 ? 55 : 32; // 增加tonode上报

          if (!originalData.tonode) {
            if (!/^(http)/.test(tonode)) {
              tonode = "".concat(location.protocol, "//").concat(tonode);
            }

            originalData.tonode = tonode;
          }
        } // 活动id或cgi


        if (!originalData.actid || !/^[1-9](\d)*$/.test(originalData.actid)) {
          // 没用活动号，或者活动号非法，用href表示cgi
          // =========filter cgi    Start=============
          var sCgi = originalData.cgi || location.href;

          if (sCgi) {
            try {
              // if (/ymzx\.qq\.com/.test(sCgi)) {
              originalData.cgi = _getRealCgi(sCgi);
              delete originalData.actid; // } else {
              //   // 其它先归0
              //   originalData.actid = 0;
              // }
            } catch (e) {// sCgi=location.href;
            }
          } // =========filter  cgi    End=============

        }

        this.postATM(originalData, comm.atmUrl, function (res) {
          if (typeof callback === 'function') {
            callback(res);
          }
        }, 3000);
      } catch (e) {
        return;
      }
    } // cgi:domain,
    // actid:domain,
    // errormsg:msg,
    // fromappid:38,
    // frommoduletype:1,
    // serialtime:parseInt(new Date().getTime()/1000),
    // struserid:"",
    // toappid:1,
    // tomoduletype:166,//前端模块
    // tointer:3,//前端安全跳转监控
    // result:type,
    // toreturncode:0

  }, {
    key: "reportVisit",
    value: function reportVisit(callback) {
      // 非QQ域名处理
      if (!_isQQDomain()) {
        return;
      } // 防止统一来源在同一页面重复上报


      if (window.ATMVisitFlag[this.visitFromModule]) {
        return;
      } // 标记此来源已经上报过


      window.ATMVisitFlag[this.visitFromModule] = true;

      try {
        var data = {
          // cgi: getRealCgi(),
          // actid: getGameId(),
          errormsg: '访问成功',
          fromappid: 38,
          // milo 应用id
          frommoduletype: this.visitFromModule,
          // 其他
          toappid: 38,
          tomoduletype: 3,
          tointer: 1,
          businesstype: getGameId(),
          struserid: miloCookie.get('openid') || this.getUin(),
          // 微信openid或者qq号
          serialtime: parseInt(new Date().getTime() / 1000),
          result: 0,
          toreturncode: 0
        }; // 先灰度ymzx上报准确url
        // if (/ymzx\.qq\.com/.test(location.href)) {

        data.cgi = _getRealCgi(); // } else {
        //   data.actid = 0;
        // }

        this.postATM(data, comm.atmUrl, function (res) {
          if (typeof callback === 'function') {
            callback(res);
          }
        }, 3000);
        return data;
      } catch (e) {
        return;
      }
    } // 发起请求，兼容IE低版本浏览器

  }, {
    key: "postATM",
    value: function postATM(data, url, callback, outTime) {
      // 非QQ域名处理，dev环境处理
      if (!_isQQDomain() || Url.request('milodev') === '1') {
        return;
      } // IE浏览器单独处理


      if (platform.msie()) {
        this.postATMForIE(data, url, callback, outTime);
        return;
      }

      try {
        // eslint-disable-next-line prefer-const
        var timeout; // 用来作超时处理

        var xmlhttp;

        if (window.XMLHttpRequest) {
          xmlhttp = new XMLHttpRequest();
        } else {
          xmlhttp = new ActiveXObject('Microsoft.XMLHTTP');
        }

        xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            if (typeof callback === 'function') {
              // 成功则清除超时设置
              if (timeout) {
                clearTimeout(timeout);
              }

              callback(xmlhttp.responseText);
            }
          }
        };

        xmlhttp.open('post', url, true);
        xmlhttp.send(JSON.stringify(data)); // 超时设置

        timeout = setTimeout(function () {
          if (xmlhttp) xmlhttp.abort();
        }, outTime);
      } catch (e) {//
      }
    } // IE下请求ATM，通过中转页面，防止安全提示

  }, {
    key: "postATMForIE",
    value: function postATMForIE(data, url, callback, outTime) {
      // 非QQ域名处理
      if (!_isQQDomain()) {
        return;
      }

      var pAIFrame = null;

      if (!g('postATMFrame')) {
        pAIFrame = document.createElement('iframe');
        pAIFrame.id = 'postATMFrame';
        pAIFrame.name = 'postATMFrame';
        pAIFrame.scrolling = 'no';
        pAIFrame.frameBorder = '0';
        pAIFrame.style.width = '0px';
        pAIFrame.style.overflow = 'hidden';
        pAIFrame.style.display = 'none';
        pAIFrame.style.position = 'absolute';
        document.body.appendChild(pAIFrame);
      } else {
        pAIFrame = g('postATMFrame');
      } // 延迟发送时间，排队，防止请求被canceled
      // 假设每一个请求需要2000ms


      var delayTime = parseInt(pAIFrame.getAttribute('data-delay') || 0); // delayTime标识下一个可以发送请求的时间点（用时间戳表示）

      var delayRequest = 0; // 下一个可以发送请求的时间点相对于当前时间的diff
      // 请求ATM动作

      var requestFunc = function requestFunc() {
        var postATMUrl = comm.crossDomainUrl; // 中转页面

        postATMUrl += "?_t=".concat(parseInt(Math.random() * 100000), "&url=").concat(encodeURIComponent(url), "&data=").concat(encodeURIComponent(JSON.stringify(data)), "&timeout=").concat(outTime || 0);
        pAIFrame.src = postATMUrl;
      }; // 如果有延迟时间并且延迟时间在当前时间之后，则延迟上报


      if (delayTime && delayTime > new Date().getTime()) {
        delayTime += 2000;
        delayRequest = delayTime - new Date().getTime();
        setTimeout(function () {
          requestFunc();
        }, delayRequest);
      } else {
        // 否则立即上报
        requestFunc();
        delayTime = new Date().getTime() + 2000;
      }

      pAIFrame.setAttribute('data-delay', delayTime);
    }
  }]);

  return ATM;
}();

var atm = new ATM();
export default atm;